(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function range(p, a, b) { return clamp((p - a) / (b - a)); }

  function init(hero) {
    if (hero.dataset.bbHeroReady) return;
    hero.dataset.bbHeroReady = '1';

    // intro once per browser session, never in the theme editor
    var intro = hero.querySelector('[data-bb-intro]');
    var seen = false;
    try { seen = sessionStorage.getItem('bb-intro-seen') === '1'; } catch (e) { seen = true; }
    if (intro && !seen && !reduce && !(window.Shopify && window.Shopify.designMode)) {
      hero.style.setProperty('--intro-delay', '1.4s');
      hero.classList.add('bb-hero--intro');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () {
        hero.classList.add('bb-hero--intro-done');
        document.documentElement.style.overflow = '';
        try { sessionStorage.setItem('bb-intro-seen', '1'); } catch (e) {}
      }, 1500);
    }

    // header floats transparently over the hero when the hero is the first section
    var wrap = hero.closest('.shopify-section');
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    var header = document.querySelector('.section-header');
    if (header && wrap && first === wrap) {
      document.documentElement.classList.add('bb-hero-overlay');
      var setH = function () {
        if (header.classList.contains('scrolled-past-header')) return;
        var h = header.offsetHeight + 'px';
        hero.style.setProperty('--bb-header-h', h);
        wrap.style.setProperty('--bb-header-h', h);
      };
      setH();
      window.addEventListener('resize', setH);
      window.addEventListener('load', setH);
    }

    var zoom = hero.querySelector('[data-bb-zoom]');
    var photo = hero.querySelector('.bb-hero__panel-img');
    var cupX = (parseFloat(getComputedStyle(hero).getPropertyValue('--cup-x')) || 40) / 100;
    var cupY = (parseFloat(getComputedStyle(hero).getPropertyValue('--cup-y')) || 70) / 100;
    var dim = hero.querySelector('[data-bb-dim]');
    var copies = Array.prototype.slice.call(hero.querySelectorAll('[data-bb-copy]'));
    var reveal = hero.querySelector('[data-bb-reveal]');
    var cup = hero.querySelector('[data-bb-cup]');
    var revealCopy = hero.querySelector('.bb-hero__reveal-copy');
    var track = hero.querySelector('.bb-hero__track');
    var scrollStory = hero.getAttribute('data-scroll') === 'true' && reveal && !reduce && !(window.Shopify && window.Shopify.designMode);
    if (scrollStory) hero.classList.add('is-scroll');

    var wide = window.matchMedia('(min-width: 750px)').matches;
    window.addEventListener('resize', function () { wide = window.matchMedia('(min-width: 750px)').matches; if (!wide) hero.style.setProperty('--grow', '0'); });
    var offset = 0, boost = 0, lastY = window.scrollY, last = performance.now(), visible = true;
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(hero);
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      boost += Math.min(Math.abs(y - lastY), 120) * 0.5;
      lastY = y;
    }, { passive: true });

    function story() {
      var r = hero.getBoundingClientRect();
      var span = Math.max(1, r.height - window.innerHeight);
      var p = clamp(-r.top / span);
      // desktop: the framed photo opens up to the full screen first
      var g = 0; // geen uitvergroting: de foto blijft rustig staan
      if (wide) hero.style.setProperty('--grow', g.toFixed(3));
      // keep the zoom centred on the cup, whatever the frame's shape
      if (zoom && photo) {
        var posY = wide ? 0.3 + (cupY - 0.3) * g : 0.3;
        photo.style.objectPosition = '50% ' + (posY * 100).toFixed(1) + '%';
        var w = zoom.clientWidth, h = zoom.clientHeight;
        var ratio = (photo.naturalWidth && photo.naturalHeight) ? photo.naturalWidth / photo.naturalHeight : 2 / 3;
        var dw, dh;
        if (w / h > ratio) { dw = w; dh = w / ratio; } else { dh = h; dw = h * ratio; }
        var ox = ((cupX * dw - (dw - w) * 0.5) / w) * 100;
        var oy = ((cupY * dh - (dh - h) * posY) / h) * 100;
        zoom.style.transformOrigin = ox.toFixed(1) + '% ' + oy.toFixed(1) + '%';
      }
      // 1) geen inzoomen meer; alleen zachte blur als de losse cup naar voren komt
      var z = ease(range(p, wide ? 0.12 : 0, 0.55));
      if (zoom) {
        zoom.style.transform = 'none';
        zoom.style.filter = 'blur(' + (range(p, 0.35, 0.6) * 6).toFixed(1) + 'px)';
      }
      // first copy slides away
      var out = range(p, 0.02, 0.2);
      copies.forEach(function (c) { c.style.opacity = (1 - out).toFixed(3); c.style.translate = '0 ' + (out * 40).toFixed(1) + 'px'; });
      // 2) background darkens, the clean cup comes forward
      if (dim) dim.style.opacity = (range(p, 0.3, 0.6) * 0.82).toFixed(3);
      var c2 = ease(range(p, 0.4, 0.72));
      if (reveal) {
        reveal.style.opacity = c2.toFixed(3);
        reveal.classList.toggle('is-on', c2 > 0.5);
      }
      if (cup) cup.style.transform = 'translateY(' + ((1 - c2) * 120).toFixed(1) + 'px) scale(' + (0.55 + c2 * 0.45).toFixed(3) + ') rotate(' + ((1 - c2) * -14 + 4).toFixed(1) + 'deg)';
      var c3 = ease(range(p, 0.55, 0.85));
      if (revealCopy) { revealCopy.style.opacity = c3.toFixed(3); revealCopy.style.translate = '0 ' + ((1 - c3) * 30).toFixed(1) + 'px'; }
    }

    function frame(now) {
      var dt = Math.min(now - last, 50); last = now;
      if (visible) {
        if (track) {
          offset -= (0.05 + boost * 0.004) * dt;
          var half = track.scrollWidth / 2;
          if (half > 0 && offset < -half) offset += half;
          track.style.setProperty('--shift', offset.toFixed(1) + 'px');
        }
        boost *= 0.92;
        if (scrollStory) story();
      }
      requestAnimationFrame(frame);
    }
    if (!reduce) requestAnimationFrame(frame);
  }
  function boot() { document.querySelectorAll('[data-bb-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
